import { t } from "@lingui/macro"
import { observer } from "mobx-react"
import { useCallback } from "react"

import { FormFieldSet } from "src/components/FormFieldSet"
import { SegmentPickerField } from "src/components/SegmentPickerField"
import { useStore } from "src/store/lib/useStore"
import { ContentItemsModalStore } from "src/modals/content-items/store"

export const PublishingSettingsSection = observer(() => {
    const store = useStore(ContentItemsModalStore)

    const handleSegmentsChange = useCallback(
        (segments: number[]) => {
            store.setSegmentIDs(segments)
        },
        [store],
    )

    const handlePublishGroupChange = useCallback(
        (publishGroupIds: number[]) => {
            store.setDimensionIDs(publishGroupIds)
        },
        [store],
    )

    return (
        <FormFieldSet
            header={t`navigation-items-view.publishing-section.used-for`}
        >
            <SegmentPickerField
                value={store.segmentIDs}
                accessGroupId={store.accessGroupId}
                onChange={handleSegmentsChange}
                disabled={store.isReadOnly}
                onPublishGroupChange={handlePublishGroupChange}
                dimensionIds={store.dimensionIDs}
            />
        </FormFieldSet>
    )
})
